<template>
  <div id="group_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
            <div v-if="isEditPage" class="text-left">
              <span class="page-title" style="width: 100%;">Vehicle Quote/Order</span>
            </div>
            <div v-else class="text-left d-flex" style="flex: 1;width: 100%;">
              <span style="width: fit-content;" class="page-title">Vehicle Quote/Order Form</span>
              <button v-if="!createButtonClickedFlag" class="btn-sm btn-primary"
                      @click="createButtonClicked('Q')" style="white-space: nowrap; margin-left: 15px;font-size: 16px;">
                <strong>Create Quote</strong>
              </button>
              <button v-if="!createButtonClickedFlag" class="btn-sm btn-primary"
                      @click="createButtonClicked('O')" style="white-space: nowrap; margin-left: 15px;font-size: 16px;">
                <strong>Place Order</strong>
              </button>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackList">
                <i class="fp-back"></i> Back
              </button>
            </div>
          </div>
        </div>
        <div v-if="isExpired" class="field-error" style="margin-top: 20px">
          <h5>Quote is expired, cannot place order!</h5>
        </div>

        <div class="container-fluid">
          <div class="admin-page-content group-crud">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="GroupForm">
                <div class="form-row">
                  <div v-show='order_quote_number' class="col-3 form-group">
                    <label class="control-label" id="order_quote_number">{{ order_quote_number_label_name }}</label>
                    <input type="text" class="form-control" v-model="order_quote_number" disabled>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-6 form-group">
                    <label class="control-label require" for="dealer_id">Dealer:</label>
                    <v-select v-if="loadAllDealers" v-model="dealer_id" name="dealer_id" label="text"
                              :filterable="false"
                              :options="dealerArr" @search="onSearchDealer" @input="onDealerChange" readonly
                              placeholder="Select Dealer" class='custom-ci-auto-search close-remove'
                              :disabled="disableDealerField || disableAllFields" @change="dealerIdChanged($event)">
                      <template slot="no-options">
                        Search Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <v-select v-else v-model="dealer_id" name="dealer_id" label="text" :filterable="false"
                              :options="dealerArr" @input="onDealerChange" readonly placeholder="Select Dealer"
                              class='custom-ci-auto-search close-remove' :disabled="disableAllFields || isEditPage"
                              @change="dealerIdChanged($event)">
                      <template slot="no-options">
                        Select Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ dealer_error_msg }}</div>
                  </div>

                  <div class="col-3 form-group">
                    <label class="control-label" for="dealer_address">Dealer Address:</label>
                    <input type="text" class="form-control" v-model="dealer_address" name="dealer_address"
                           id="dealer_address" placeholder="Dealer Address" disabled>
                    <div class="field-error"></div>
                  </div>
                  <div class="col-3 form-group">
                    <label class="control-label" for="user_email">Created By:</label>
                    <input type="text" class="form-control" v-model="user_email" name="user_email"
                           id="user_email" disabled>
                    <div class="field-error"></div>
                  </div>
                </div>
                <!--  Commenting out, because the order type selection is being removed for now. -->
                <!--
                <div class="form-row">
                  <div class="col-sm-2 form-group">
                    <label class="control-label require" for="price_type">Select Order Type:</label>
                    <div class="custome-radiobtn mt-1">
                      <div class="form-check form-check-inline">
                        <label class="boolean optional radio-custom" for="custom">Custom
                          <input type="radio" v-model="orderType" :value="'Custom'" id="custom"
                                 :disabled="disableAllFields">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="boolean optional radio-custom" for="in_stock"> In Stock
                          <input type="radio" v-model="orderType" :value="'In Stock'" id="in_stock"
                                 :disabled="disableAllFields">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                    <div class="field-error">{{ order_type_error_msg }}</div>
                  </div>
                  <div class="col-sm-7 form-group">
                    <div class="row" v-if="orderType != 'Only Extended Warranty'">
                      <div class="col-10 form-group">
                        <label for="vehicle_id" class="control-label require">VIN:</label>
                        <v-select
                          v-model="vehicle_id"
                          id="vehicle_select"
                          name="vehicle_id"
                          label="text"
                          :filterable="false"
                          :options="vehicleArr"
                          @search="onSearchAsset"
                          placeholder="Search Vehicle with VIN or Asset#"
                          class="custom-ci-auto-search"
                          :disabled="disableInStockVin || disableAllFields"
                        >
                          <template slot="no-options">
                            Search Vehicle...
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.text }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.text }}
                            </div>
                          </template>
                        </v-select>
                        <div class="field-error">{{ asset_error_msg }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              end of the comment -->

                <!--The vehicle details for the instock order starts-->
                <!--
                <div class="form-row">
                  <div v-if="orderType == 'In Stock' && vehicle_id != null" class="col-sm-8 form-group">
                    <label class="font-bold"> VEHICLE DETAILS </label>
                    <table class="table table-sm table-bordered">
                      <tr class="table-secondary">
                        <td>Year:</td>
                        <td class="text-right">{{ vehicle_id.year }}</td>
                      </tr>
                      <tr class="table-secondary">
                        <td>Make:</td>
                        <td class="text-right">{{ vehicle_id.make }}</td>

                      </tr>
                      <tr class="table-secondary">
                        <td>Model:</td>
                        <td class="text-right">{{ vehicle_id.model }}</td>
                      </tr>
                      <tr class="table-secondary">
                        <td>Color:</td>
                        <td class="text-right">{{ vehicle_id.color }}</td>
                      </tr>
                      <tr class="table-secondary">
                        <td>Option:</td>
                        <td class="text-right">{{ vehicle_id.option }}</td>
                      </tr>
                      <tr class="table-secondary">
                        <td>Wheelbase:</td>
                        <td class="text-right">{{ vehicle_id.wheelbase }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                -->
                <!--The vehicle details for the instock order ends-->

                <!--  Section for the Admin User -->
                <div class="form-row" v-if="orderStatus == 'O'">
                  <div class="col-sm-2 form-group" v-if="canAssignVehicle && assignedVehicles.length < 1">
                    <button
                      type="submit"
                      id="createGroupBtn"
                      class="btn btn-primary"
                      v-on:click.prevent="assignVehicle()"
                    >
                      <i class="fp-truck-asset"> </i> Assign Vehicles
                    </button>
                  </div>
                  <div class="col-sm-6 form-group" v-if="assignedVehicles.length > 0">
                    <label class="control-label">
                      <h2>
                        Assigned Vehicles
                      </h2>
                    </label>
                    <div class="table-responsive-sm mt-2">
                      <table class="table table-bordered table-sm" style="table-layout: fixed;">
                        <thead>
                        <tr class="table-primary">
                          <th scope="col" style="width: 4%;">S.N</th>
                          <th scope="col" style="width: 10%;">VIN</th>
                          <th scope="col" style="width: 10%;" v-if="canAssignVehicle">ACTION</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row,index) in assignedVehicles" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <!--row.vin-->
                            {{ row.vin }}
                          </td>
                          <td class="text-center valign-middle" v-if="canAssignVehicle">
                            <template v-if="canAssignVehicle">
                              <a href="javascript:void(0);" v-on:click="unAssignVehicle(index);"> <i
                                class="fp-delete"></i> </a>
                            </template>
                            <template v-else>
                              <span class="close-row"> _ </span>
                            </template>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="btn-groups mb-4" v-if="canAssignVehicle && assignedVehicles.length < order_qty">
                      <template>
                        <button type="submit" v-on:click.prevent="assignVehicle()" class="btn btn-primary">
                          <i class="fp-add"></i> Assign Another Vehicle
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
                <!--  Section for the Admin User Ends -->

                <div class="form-row">
                  <div class="col-sm-3 form-group">
                    <label class="control-label require" for="price_type">Select Class:</label>
                    <v-select v-model="select_class" name="select_class" placeholder="Select Class" label="text"
                              :options="selectClassArr" :disabled="disableAllFields" :searchable="false"
                              @change="classChanged($event)">
                    </v-select>
                    <div class="field-error">{{ select_class_error_msg }}</div>
                  </div>
                  <div class="col-sm-3 form-group">
                    <label class="control-label require" for="price">Select Battery Size:</label>
                    <v-select v-model="batterySize" name="batterySize" placeholder="Select Battery Size" label="text"
                              :options="batterySizeArr" @input="onChangeSize()"
                              :disabled="disableAllFields"
                              :searchable="false"
                              @change="batterySizeChanged($event)">
                    </v-select>
                    <div class="field-error">{{ select_battery_size_error_msg }}</div>
                  </div>
                  <div class="col-sm-3 form-group">
                    <label class="control-label require" for="question_one">Select Wheelbase:</label>
                    <v-select ref="wheelbaseDropDown" v-model="wheelbase" name="wheelbase" placeholder="Select Wheelbase" label="text"
                              :options="wheelbaseArray" :disabled="disableAllFields"
                              :searchable="false"
                              @change="wheelbaseChanged($event)">
                      <span
                        v-if="batterySize == null || batterySize === ''"
                        slot="no-options"
                        @click="$refs.wheelbaseDropDown.open = false"
                      >
                        Select The Battery Size First!
                      </span>
                    </v-select>
                    <div class="field-error">{{ select_wheelbase_error_msg }}</div>
                  </div>
                  <div class="col-sm-3 form-group">
                    <label class="control-label require" for="vehicle_color">{{ color_spelling }}:</label>
                    <v-select v-model="vehicle_color" name="vehicle_color" placeholder="Enter Vehicle Color"
                              label="text"
                              :options="colorsArr" disabled
                              @change="colorChanged($event)">
                    </v-select>
                    <div class="field-error">{{ select_color_error_msg }}</div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-sm-8 form-group">
                    <label class="control-label require" for="question_two">Vehicle Options</label>
                    <v-select class="custom_vehicle_select"
                              v-model="vehicle_option" name="vehicle_option" placeholder="Vehicle Option" label="text"
                              :options="vehicleOptionArr"
                              :disabled="disableAllFields"
                              @change="vehicleOptionChanged($event)">
                    </v-select>
                    <div class="field-error">{{ select_vehicle_option_error_msg }}</div>
                  </div>

                  <!-- these are also fields relevent to extended warraty -->
                  <!--
                  <div v-if="showWarrantyCheckboxes" class="col-sm-4 form-group">
                    <div class="row">
                      <div class="custom-checkbox col-6">
                        <label class="control-label" for="vehicle_type_code"></label><br>
                        <label for="highVoltageBattery" class="checkbox-custom"> High Voltage Battery
                          <input type="checkbox" v-model="highVoltageBattery" id="highVoltageBattery"
                                 name="highVoltageBattery">
                          <span class="checkmark"></span>
                        </label>
                        <div class="field-error"></div>
                      </div>
                      <div class="custom-checkbox col-6">
                        <label class="control-label" for="vehicle_type_code"></label><br>
                        <label for="powerTrain" class="checkbox-custom"> Power Train (PT)
                          <input type="checkbox" v-model="powerTrain" id="powerTrain" name="powerTrain">
                          <span class="checkmark"></span>
                        </label>
                        <div class="field-error"></div>
                      </div>
                      <div class="custom-checkbox col-6">
                        <label class="control-label" for="vehicle_type_code"></label><br>
                        <label for="hvee" class="checkbox-custom"> HV Electrical Equip. (HVEE)
                          <input type="checkbox" v-model="hvee" id="hvee" name="hvee">
                          <span class="checkmark"></span>
                        </label>
                        <div class="field-error"></div>
                      </div>
                      <div class="custom-checkbox col-6">
                        <label class="control-label" for="vehicle_type_code"></label><br>
                        <label for="allBundle" class="checkbox-custom"> All (bundle disc.)
                          <input type="checkbox" v-model="allBundle" id="allBundle" name="allBundle">
                          <span class="checkmark"></span>
                        </label>
                        <div class="field-error"></div>
                      </div>
                    </div>
                  </div>
                  -->
                  <!-- extended warranty ends -->

                  <div class="col-sm-4 form-group" v-if="orderType != 'Only Extended Warranty'">
                    <label class="control-label require" for="question_seven">Delivery Area:</label>
                    <v-select v-model="deliveryArea" name="deliveryArea" placeholder="Select Delivery Area" label="text"
                              :options="deliveryAreaArr" :disabled="disableAllFields"
                              :searchable="false"
                              @change="deliveryAreaChanged($event)">
                    </v-select>
                    <div class="field-error">{{ select_delivery_area_error_msg }}</div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-2 form-group">
                    <label class="control-label require" for="price_type">Order For:</label>
                    <div class="custome-radiobtn">
                      <div class="form-check form-check-inline">
                        <label class="boolean optional radio-custom" for="dealer_custom">Dealer Stock
                          <input type="radio" v-model="orderingFor" :value="'dealer_stock'" id="dealer_custom"
                                 :disabled="disableAllFields">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="boolean optional radio-custom" for="dealer_in_stock"> Customer
                          <input type="radio" v-model="orderingFor" :value="'consumer'" id="dealer_in_stock"
                                 :disabled="disableAllFields">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                    <div class="field-error">{{ ordering_for_error_msg }}</div>
                  </div>

                  <div class="col-6 form-group">
                    <template v-if="!(orderingFor !== 'consumer' || disableAllFields)">
                      <div class="d-flex justify-content-between">
                        <label class="control-label require" for="consumer_id">Customer:</label>
                        <router-link
                          v-if="canAddCustomer"
                          class="color-blue link-text"
                            v-bind:to="{ name: 'ConsumerCreate', params: { newCustomer: '', redirectFrom: 'VehicleOrderForm'}, query: {dealerId: dealer_id ? dealer_id.value : ''}  }"
                          target="_blank">
                          <i class="fp-add" style="font-size:8px;font-weight:bold;"></i>
                          Add Customer
                        </router-link>
                      </div>
                    </template>
                    <template v-else>
                      <label class="control-label" for="consumer_id">Customer:</label>
                    </template>
                    <v-select v-model="consumer_id" name="consumer_id" label="text" :filterable="false"
                              :options="consumerArr" @search="onSearchConsumer" @input="onConsumerChange"
                              placeholder="Select Customer" class='custom-ci-auto-search close-remove'
                              :disabled="((orderingFor != 'consumer')) || disableAllFields"
                              @change="customerChanged($event)"
                    >
                      <template slot="no-options">
                        Search Customer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ consumer_error_msg }}</div>
                  </div>

                  <div class="col-4 form-group">
                    <label class="control-label" for="consumer_address">Customer Address:</label>
                    <input type="text" class="form-control" v-model="consumer_address" name="consumer_address"
                           id="consumer_address" placeholder="Customer Address" disabled>
                    <div class="field-error"></div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="alert alert-warning hide offset-sm-2 col-sm-4" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
                      aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
              </form>
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-4 form-group">
                      <label class="control-label require" for="incentive_program">Incentive Program:</label>
                      <div class="custome-radiobtn">
                        <div class="form-check form-check-inline">
                          <label class="boolean optional radio-custom" for="incentive_yes">Yes
                            <input type="radio" v-model="incentiveProgram" :value="'yes'" id="incentive_yes"
                                   :disabled="disableAllFields">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <label class="boolean optional radio-custom" for="incentive_no"> No
                            <input type="radio" v-model="incentiveProgram" :value="'no'" id="incentive_no"
                                   :disabled="disableAllFields">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div class="field-error">{{ incentive_program_error_msg }}</div>
                    </div>
                    <div class="col-8 form-group">
                      <label v-if="incentiveProgram === 'yes'" class="control-label require"
                             for="incentive_program_title">Incentive Program Title:</label>
                      <label v-else class="control-label" for="incentive_program_title">Incentive Program Title:</label>

                      <span style="font-size: 14px;">{{ incentiveProgramTitleCharCount }}/250</span>
                      <input type="text" class="form-control" v-model="incentiveProgramTitle"
                             name="incentive_program_title"
                             id="incentive_program_title" placeholder="Incentive Program Title"
                             :disabled="incentiveProgram === 'no' || disableAllFields">
                      <div class="field-error">{{ incentive_program_title_error_msg }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 form-group">
                      <div class="d-flex justify-content-between">
                        <label class="control-label"
                               :class="createButtonClickedFlag == 'O' ? 'require' : ''" id="purchase_order_no">Purchase
                          Order#</label>
                        <span style="font-size: 14px;">{{ purchaseOrderNoCharCount }}/50</span>
                      </div>
                      <input type="text" class="form-control" placeholder="Purchase Order#" v-model="purchase_order_no"
                             :disabled="disablePurchaseOrderField || isEditPage || disableAllFields">
                      <div v-if="purchase_order_error_msg != ''" class="field-error">{{
                          purchase_order_error_msg
                        }}
                      </div>
                      <div v-else class="field-message">{{ purchase_order_msg }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col form-group">
                      <div>
                        <label v-if="!disableAllFields" class="control-label mb-0" id="upload_purchase_order">Upload Purchase Order</label>
                        <DropZone ref="formDropzoneComponentRef" :uniqueRef="'formDropzoneInstance'"
                                  :showDropzone="dropZonePreviewFiles.length < 1"
                                  :showUploadedFiles="dropZonePreviewFiles && dropZonePreviewFiles.length > 0"
                                  :maxFileLimit='5' :docErrorMsg="doc_error_msg"
                                  :dropZonePreviewFiles="dropZonePreviewFiles"
                                  :acceptedFiles="'.jpg, .jpeg, .png, .pdf, .docx, .doc'"
                                  :fileSizeLimit="10"
                                  :mainDivCol="'col-md-12'"
                                  :canRemoveUploadedFiles="false"
                                  :dropzoneLabel="''" @dropzone-update-files="updateFiles"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!--                the order quantity and calculations-->
                <div class="col-6">
                  <div class="row">
                    <div class="col-2 form-group"></div>
                    <div class="col-6 form-group">
                      <label class="control-label require" for="order_qty">Order Quantity:</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="order_qty"
                        name="order_qty"
                        id="order_qty"
                        placeholder="Enter Order Quantity"
                        @keypress="filterWholeNumericValue"
                        :disabled="disableAllFields"
                        max="100"
                      >
                      <div class="field-error">{{ order_quantity_error_msg }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 form-group"></div>
                    <div class="col-md-10 form-group">
                      <div class="radius-5">
                        <label class="font-bold"> VEHICLE DETAILS </label>
                        <table class="table table-sm table-bordered">
                          <thead>
                          <tr class="table-primary">
                            <th>Available Vehicles</th>
                            <th v-if="canAssignVehicle">Vehicles Pending Sale</th>
                            <th>Order Quantity</th>
                          </tr>
                          </thead>
                          <tbody class="no-translate">
                          <tr class="table-secondary">
                            <td>{{ available_vehicles }}</td>
                            <td v-if="canAssignVehicle">{{ vehicles_pending_for_sale }}</td>
                            <template v-if="!orderQtyHasError">
                              <td>{{ order_qty }}</td>
                            </template>
                            <template v-else>
                              <td>-</td>
                            </template>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 form-group"></div>
                    <div class="col-10 form-group" v-if="orderType == 'Custom'">
                      <div class="radius-5">
                        <label class="font-bold"> ORDER DETAILS </label>
                        <table class="table table-sm table-bordered">
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>Base Price:</td>
                            <td class="text-right">{{ currencyFormat(basePrice) }}</td>
                          </tr>
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>Vehicle Option Price:</td>
                            <td class="text-right">{{ currencyFormat(vehicleOptionPrice) }}</td>
                          </tr>
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>{{ color_spelling }} Price:</td>
                            <td class="text-right">{{ currencyFormat(colorPrice) }}</td>
                          </tr>
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>Total Vehicle Price:</td>
                            <td class="text-right">{{ currencyFormat(vehiclePrice) }}</td>
                          </tr>
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>Delivery Fee:</td>
                            <td class="text-right">{{ currencyFormat(deliveryFee) }}</td>
                          </tr>
                          <tr class="table-secondary">
                            <td>Total Fee:</td>
                            <td class="text-right">{{ currencyFormat(totalFee) }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="col-10 form-group" v-else>
                      <div class="radius-5">
                        <label class="font-bold"> ORDER DETAILS </label>
                        <table class="table table-sm table-bordered">
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>Vehicle Price (Per Vehicle):</td>
                            <td class="text-right">{{ currencyFormat(purchase_price) }}</td>
                          </tr>
                          <tr class="table-secondary" v-if="orderType != 'Only Extended Warranty'">
                            <td>Delivery Fee (Per Vehicle):</td>
                            <td class="text-right">{{ currencyFormat(deliveryFee) }}</td>
                          </tr>
                          <tr class="table-secondary">
                            <td>Total Fee (Per Vehicle):</td>
                            <td class="text-right">{{ currencyFormat(totalFee) }}</td>
                          </tr>
                          <tr class="table-secondary">
                            <template v-if="!orderQtyHasError">
                              <td>Grand Total Fee for - {{ order_qty }} Vehicles:</td>
                            </template>
                            <template v-else>
                              <td>Grand Total Fee for - Vehicles:</td>
                            </template>
                            <td class="text-right">{{ currencyFormat(grandTotalFee) }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-groups" v-if="(!isEditPage || orderStatus == 'Q') && !isExpired">
                <button
                  v-if="orderStatus != 'Q' && !got_quote && createButtonClickedFlag == 'Q'"
                  type="submit"
                  id="createGroupBtn"
                  class="btn btn-primary"
                  v-on:click.prevent="showSwalConfirmOrder('Q')"
                  :disabled="disableQuoteButton || disableAllFields"
                >
                  <i class="fp-view"> </i> Quote
                </button>
                <button v-if="createButtonClickedFlag == 'O' || order_quote_number"
                        type="submit" id="createGroupBtn" class="btn btn-primary"
                        v-on:click.prevent="showSwalConfirmOrder('O')"
                        :disabled="order_quote_number == '' && disableAllFields">
                  <i class="fp-save"> </i> {{ orderButtonName }}
                </button>
                <button v-if="!isEditPage && createButtonClickedFlag"
                        type="submit" class="btn btn-secondary" v-on:click.prevent="BackList">
                  <i class="fp-back"></i> Cancel
                </button>
              </div>
              <div v-else class="btn-groups">
                <template v-if="canAssignVehicle && isEditPage">
                  <button
                    type="submit" id="createGroupBtn" class="btn btn-primary"
                    v-on:click.prevent="updateAndClose()" :disabled="errorOnLoad"
                  >
                    Update & Close
                  </button>
                  <button
                    type="submit" id="createGroupBtn" class="btn btn-primary"
                    v-on:click.prevent="discardChangesSwal()" :disabled="assignedVehiclesAreTheSame || errorOnLoad"
                  >
                    Discard Changes
                  </button>
                </template>
              </div>
            </section>
          </div>
        </div>
        <div class="modal fade" id="purchaseOrder" tabindex="-1" role="dialog"
             aria-labelledby="purchaseOrderLabel" data-backdrop="static">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
              </div>
              <div class="pl-5 pr-5 mt-1">
                <p>To convert this quote into an order please update the following</p>
                <div class="form-row">
                  <div class="col-12 form-group">
                    <div class="d-flex justify-content-between">
                      <label class="control-label require" for="update_purchase_order_no">Please enter a valid purchase
                        order number</label>
                      <span style="font-size: 14px;">{{ update_purchase_order_no_count }}/50</span>
                    </div>
                    <input type="text" class="form-control" v-model.trim="update_purchase_order_no"
                           id="update_purchase_order_no" placeholder="Purchase Order#" name="update_purchase_order_no">
                    <span class="field-error">{{ update_purchase_order_no_error_msg }}</span>
                  </div>
                </div>
                  <DropZone ref="modalDropzoneComponentRef" :uniqueRef="'modalDropzoneInstance'"
                    :showDropzone="true"
                    :showUploadedFiles="dropZonePreviewFiles && dropZonePreviewFiles.length > 0"
                    :maxFileLimit='5' :docErrorMsg="doc_error_msg"
                    :dropZonePreviewFiles="dropZonePreviewFiles"
                    :acceptedFiles="'.jpg, .jpeg, .png, .pdf, .docx, .doc'"
                    :fileSizeLimit="10"
                    :mainDivCol="'col-md-12'"
                    :dropzoneRequired="false"
                    :dropzoneLabel="'Please attach a copy of purchase order'"
                    :dropzoneCol="'col-12'" :dropzoneFilesCol="'col-12'"
                    @dropzone-update-files="updateFiles"
                    :canRemoveUploadedFiles="false"
                    :noteBelowDropzone="noteForDropZone"
                  />
              </div>
              <div class="d-flex justify-content-around mt-4 mb-3">
                <button type="button"
                        id="purchaseOrderSubmitBtn" @click="checkPurchaseOrder()" class="btn-lg btn-primary"
                        style="width: 150px;">Place Order
                </button>
                <button type="button" @click="closePurchaseOrderModal()" class="btn-lg btn-primary"
                        style="width: 150px;">Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins'
import LoadingContent from "@/components/LoadingContent.vue";

Vue.component("loading-content", LoadingContent);
import {contractMixins} from '../../mixins/contractMixins';
import {useAssignedVehiclesList} from "../../store/AssignedVehiclesList";

import DropZone from '../DropZone.vue';

export default {
  name: "CustomerOrderForm",
  components: {
    appFooter: () => import('@/components/Footer'),
    DropZone,
  },
  metaInfo() {
    return {title: (this.$route.params.id > 0) ? "Update Vehicle Order Form | " + process.env.COPYRIGHT_NAME : "Create Vehicle Order Form | " + process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    orderType: "",
    // extended Warranty Type might be used in the future
    //orderTypeArr: ["Custom", "In Stock", "Only Extended Warranty"],
    orderTypeArr: ["Custom", "In Stock"],
    select_class: "",
    selectClassArr: ["e16", "e18"],
    batterySize: "",
    batterySizeArr: ["M", "L"],
    wheelbase: "",
    wheelbaseArray: [],
    wheelbaseArrayM: ["M134", "M152", "M175", "M187"],
    wheelbaseArrayL: ["L175", "L187"],
    addPto: "",
    addPtoArr: ["No", "Yes, General", "Yes, Reefer"],
    extendedWarranty: "",
    showWarrantyCheckboxes: false,
    extendedWarrantyArr: ["Yes", "No"], // need to add checkboxes
    colorWhite: "",
    colorWhiteArr: ["Yes", "No"],
    deliveryArea: "",
    deliveryAreaUSArr: ["Dealer’s Transporter", "Southern CA", "Northern CA", "NY/NJ", "TX", "NE", "OR/WA"],
    order_type_error_msg: "",
    showQuestion: true,
    highVoltageBattery: false,
    powerTrain: false,
    hvee: false,
    allBundle: false,
    checkboxValue: "",
    checked: "",
    loading: false,
    name_error_msg: "",
    extendedWarrantyFee: 0,
    deliveryFee: 0,
    vehiclePrice: 0,
    vehicle_id: null,
    vehicleArr: [],
    customer_id: null,
    customerArr: [],
    consumer_for: false,
    order_no: "",
    vehicle_color: "White",
    got_quote: false,
    APIResponse: false,

    dealerArr: [],
    dealer_id: '',
    dealer_error_msg: '',

    dealer_address: '',
    // colorsArr: [
    //   "Shannon Blue (T89)",
    //   "Arcadia Silver (H90)",
    //   "Forest Green (G58)",
    //   "Jupiter Green (G10)",
    //   "Mars Red (R23)",
    //   "Solid Black (X01)"
    // ],
    colorsArr: ['White'],
    totalFee: 0,
    consumerArr: [],
    consumer_id: '',
    consumer_error_msg: '',

    consumer_address: '',

    asset_error_msg: '',
    path: '',
    vinArr: [],
    isEditPage: false,
    customerOrderId: 0,

    select_class_error_msg: '',
    select_battery_size_error_msg: '',
    select_wheelbase_error_msg: '',
    select_vehicle_option_error_msg: '',
    select_ext_warranty_error_msg: '',
    select_delivery_area_error_msg: '',
    is_the_color_white_error_msg: '',
    select_color_error_msg: '',
    velocity_env: process.env.NODE_ENV,
    disableDealerField: false,
    loadAllDealers: false,
    disableInStockVin: true,
    disableCustomFields: true,
    orderButtonName: "Place Order",
    disableQuoteButton: false,
    disableAllFields: false,
    orderStatus: "",
    orderingFor: "",
    incentiveProgram: "no",
    incentiveProgramTitle: "",
    incentive_program_error_msg: "",
    incentive_program_title_error_msg: "",
    ordering_for_error_msg: "",
    order_quote_number: '',
    order_quote_number_label_name: '',
    dropZonePreviewFiles: [],
    doc_error_msg: "",
    files: [],
    purchase_order_no: '',
    purchase_order_error_msg: '',
    purchase_order_msg: '',
    disablePurchaseOrderField: false,
    purchaseOrderNoCharCount: 0,
    incentiveProgramTitleCharCount: 0,
    user_email: '',
    update_purchase_order_no_count: 0,
    update_purchase_order_no: '',
    update_purchase_order_no_error_msg: '',
    logoPath: '',
    isExpired: false,
    vehicleOptionArr: [],
    vehicle_option: '',
    customOrderPricesArr: [],
    basePrice: 0,
    vehicleOptionPrice: 0,
    colorPrice: 0,
    createButtonClickedFlag: '',
    deliveryAreaCAArr: ["Dealer’s Transporter CA", "Greater Vancouver", "Vancouver Island", "Quebec", "Ontario"],
    deliveryAreaArr: [],
    vehicleSpecificationFields: [
      'select_class',
      'batterySize',
      'wheelbase',
      'vehicle_option',
      'vehicle_color'
    ],
    order_qty: 0,
    available_vehicles: 0,
    purchase_price: 0,
    grandTotalFee: 0,
    order_quantity_error_msg: "",
    vehicles_pending_for_sale: 0,
    assignedVehiclesList: useAssignedVehiclesList(),
    canAssignVehicle: false,
    errorOnLoad: false,
    bypassConfirmation: false,
    orderQtyHasError: false,
    previewFilesOnLoad: [],
    canAddCustomer: false,
  }),
  beforeRouteLeave(to, from, next) {

    if (this.canAssignVehicle && this.isEditPage && (!this.bypassConfirmation)) {
      if (this.assignedVehiclesAreTheSame) {
        next();
      } else {
        if (confirm("Vehicle assignment changes will not be saved!")) {
          next(); // Proceed with navigation
        } else {
          // Restore the URL without query parameters
          next(false); // Cancel navigation

          // Directly update the browser URL without affecting history
          window.history.replaceState(null, "", from.path);
        }
      }
    } else {
      next();
    }
  },
  created: function () {
    this.logoPath = process.env.LOGO_PATH;
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  computed: {
    basePriceName() {
      return `${this.select_class}${this.batterySize}/${this.wheelbase}`;
    },
    calculatedVehiclePrice() {
      return (this.basePrice + this.vehicleOptionPrice + this.colorPrice);
    },
    // calculatedTotalFee() {
    //   return (this.vehiclePrice + this.deliveryFee);
    // },
    calculateTotalFromPurchasePrice() {
      return (this.purchase_price + this.deliveryFee);
    },
    calculateGrandTotalFee() {
      if (!this.orderQtyHasError) {
        return (this.totalFee * this.order_qty);
      } else {
        return 0;
      }
    },
    assignedVehicles() {
      return useAssignedVehiclesList().vehicles;
    },
    unAssignedVehicles() {
      return useAssignedVehiclesList().unAssignedVehicles;
    },
    assignedVehiclesOnLoad() {
      return useAssignedVehiclesList().assignedVehiclesOnLoad;
    },
    assignedVehiclesAreTheSame() {
      var comparing = (this.assignedVehiclesOnLoad === JSON.stringify(this.assignedVehicles));
      return comparing;
    },
    noteForDropZone(){
      if(this.dropZonePreviewFiles.length > 0){
        return "Uploaded Files Will Be Overridden If New Files Are Uploaded!";
      }else{
        return null;
      }
    }
  },
  watch: {

    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (self.velocity_env === 'velev' || self.velocity_env === 'velev_test') {
            if (element.name === 'ev_add_vehicle_order') {
              self.cantAccessPage = true;
            }
            if (element.name === 'ev_load_all_dealer_dropdown') {
              self.loadAllDealers = true;
            }
            if (element.name === 'ev_assign_vehicle_to_order') {
              self.canAssignVehicle = true;
            }
            if (element.name == 'ev_add_customer') {
              self.canAddCustomer = true;
            }
          } else {
            if (element.name === 'add_customer_order_price') {
              self.cantAccessPage = true;
            }
          }
        }
        if (!self.loadAllDealers) {
          let userObj = JSON.parse(localStorage.getItem("user_obj"));
          self.loadUserDealerMapper(userObj.id);
        }
      }

    },
    APIResponse: function (val) {
      var self = this;
      self.disableDealerField = false;
      if (val) {
        if (self.customerAddressArr.customer_name != null && self.customerAddressArr.customer_code != null) {
          self.dealer_id = {
            text: self.customerAddressArr.customer_code + " | " + self.customerAddressArr.customer_name,
            value: self.customerAddressArr.customer_id,
            contact: self.customerAddressArr.customer_contact_id
          };
          self.dealer_address = self.customerAddressArr.address_1;
          self.disableDealerField = true;
        }
      }
    },

    extendedWarranty: function (extendedWarranty) {
      var self = this;
      if (self.extendedWarranty == "Yes") {
        self.showWarrantyCheckboxes = true;
      } else {
        self.showWarrantyCheckboxes = false;
      }
    },

    orderType: function (orderType) {
      var self = this;
      self.consumer_for = false;
      self.disableInStockVin = true;
      if (self.orderType == "In Stock" || self.orderType == 'Only Extended Warranty') {
        if (self.orderType == "In Stock") {
          self.disableInStockVin = false;
        }
        self.disableCustomFields = true;
        self.showQuestion = false;
      } else {
        self.disableCustomFields = false;
        self.showQuestion = true;
      }

      if (self.orderType == 'Only Extended Warranty') {
        self.extendedWarranty = "Yes";
      }


      if (self.customerOrderId == 0) {
        self.select_class = "";
        self.batterySize = "";
        self.wheelbase = "";
        self.vehicle_option = "";
        self.showWarrantyCheckboxes = false;
        self.colorWhite = "";
        self.deliveryArea = "";
        self.order_type_error_msg = "";
        self.highVoltageBattery = false;
        self.powerTrain = false;
        self.hvee = false;
        self.allBundle = false;
        self.checkboxValue = "";
        self.checked = "";
        self.name_error_msg = "";
        self.extendedWarrantyFee = 0;
        self.deliveryFee = 0;
        self.vehiclePrice = 0;
        self.vehicle_id = null;
        self.vehicleArr = [];
        self.customer_id = null;
        self.customerArr = [];
        self.order_no = "";
        self.vehicle_color = "";
        self.got_quote = false;
        self.totalFee = 0;
        self.consumerArr = [];
        self.consumer_id = '';
        self.consumer_address = '';
      }
      self.consumer_error_msg = '';


      self.asset_error_msg = '';
    },
    customerOrderId(customerOrderId) {
      var self = this;
      if (self.customerOrderId > 0) {
        self.disableAllFields = true;
      } else {
        self.disableAllFields = false;
      }
    },
    createButtonClickedFlag(value) {
      if (value) {
        this.disableAllFields = false;
      } else {
        this.disableAllFields = true;
      }
    },
    purchase_order_no(value) {
      if (value.length > 50) {
        this.purchase_order_no = value.substring(0, 50);
      }
      this.update_purchase_order_no = value;
      this.purchaseOrderNoCharCount = value.length;
    },
    incentiveProgramTitle(value) {
      if (value.length > 0) {
        this.incentive_program_title_error_msg = "";
      }
      if (value.length > 250) {
        this.incentiveProgramTitle = value.substring(0, 250);
      }
      this.incentiveProgramTitleCharCount = value.length;
    },
    incentiveProgram(value) {
      if (value == "no") {
        this.incentive_program_title_error_msg = "";
        this.incentiveProgramTitle = "";
      }
    },
    basePriceName(value) {
      if (!this.isEditPage) {
        const price = this.getCustomPrice(value);
        this.basePrice = this.ensureNumeric(price);
      }
    },
    vehicle_option(value) {
      if (!this.isEditPage) {
        if (value !== "" && value != null) {
          this.vehicleOptionPrice = this.ensureNumeric(value.price);
        } else {
          this.vehicleOptionPrice = 0;
        }
      }
    },
    deliveryArea(value) {
      if (!this.isEditPage) {
        const price = this.getCustomPrice(value);
        this.deliveryFee = this.ensureNumeric(price);
      }
    },
    colorWhite(value) {
      if (!this.isEditPage) {
        if (value === 'Yes') {
          const price = this.getCustomPrice(value);
          this.colorPrice = this.ensureNumeric(price);
        }
      }
    },
    vehicle_color(value) {
      if (!this.isEditPage) {
        if (value != null) {
          const price = this.getCustomPrice(this.colorWhite);
          this.colorPrice = this.ensureNumeric(price);
        } else {
          this.colorPrice = 0;
        }
      }
    },
    calculatedVehiclePrice(value) {
      if (!this.isEditPage) {
        this.vehiclePrice = this.ensureNumeric(value);
      }
    },
    calculatedTotalFee(value) {
      if (!this.isEditPage) {
        this.totalFee = this.ensureNumeric(value);
      }
    },
    calculateTotalFromPurchasePrice(value) {
      if (!this.isEditPage) {
        this.totalFee = this.ensureNumeric(value);
      }
    },
    calculateGrandTotalFee(value) {
      if (!this.isEditPage) {
        this.grandTotalFee = this.ensureNumeric(value);
      }
    },
    vehicle_id(value) {
      if (!this.isEditPage) {
        if (value != null && value != "") {
          this.vehiclePrice = this.ensureNumeric(value.price);
        } else {
          this.vehiclePrice = 0;
        }
      }
    },
    order_qty(value) {
      if (value > 100) {
        this.order_quantity_error_msg = "Maximum quantity of 100 vehicles can be placed per order/quote!";
        this.orderQtyHasError = true;
      }else if (!/^\d+$/.test(value)) {
        this.order_quantity_error_msg = 'Please enter a valid whole number!';
        this.orderQtyHasError = true;
      } else {
        this.order_quantity_error_msg = "";
        this.orderQtyHasError = false;
      }
    },
    errorOnLoad(value) {
      if (value) {
        this.disableAllFields = true;
      }
    },
    update_purchase_order_no(value){
      if (value.length > 50){
        this.update_purchase_order_no = value.substring(0,50);
      }
      this.update_purchase_order_no_count = value.length;
    },
    batterySize(value){
      if (value === '' || value === null) {
        this.wheelbase = null;
        this.wheelbaseArray = [];
      }
    }
  },
  mounted: function () {
    var self = this;
    self.bypassConfirmation = false;
    var unitData = self.$route.params.unitNo; // this value is populated when, redirected from the asset list page
    if (unitData != undefined) {
      self.orderType = "In Stock";
      self.onSearchAsset(unitData, "loading");
    }
    self.checkboxValue = 0;
    self.getPermissions();
    self.loadFieldData(['customer_address', 'vehicle_options']);
    if (process.env.REGION === "US") {
      this.deliveryAreaArr = this.deliveryAreaUSArr;
    } else {
      this.deliveryAreaArr = this.deliveryAreaCAArr;
    }
    setTimeout(function () {
      var path = window.location.pathname;
      var segments = path.split("/");
      if (segments[3]) {
        self.isEditPage = true;
        self.customerOrderId = segments[3];
        // if not redirected from the assetVehicle list page, reset the assignedVehicles
        self.onLoadCustomerOrder();
      } else {
        self.isEditPage = false;
        self.getCustomOrderVehiclePrices();
        self.customerOrderId = 0;
        var userObj = localStorage.getItem("user_obj");
        if (userObj != null) {
          var userJson = JSON.parse(userObj);
          self.user_email = userJson.email;
        }
      }
      if (self.createButtonClickedFlag == '') {
        self.disableAllFields = true;
      }
      self.$nextTick(() => {
        self.$watch(
          () => self.vehicleSpecificationFields.map((field) => self[field]),
          () => {
            if (self.areAllFieldsValid()) {
              self.getVehicleSpecificationDetails();
            }
          },
          {deep: true}
        );
      });
      self.disableFormDropZone();
    }, 250);
  },
  methods: {
    updateFiles(files) {
        this.files = files;
    },
    disableFormDropZone(retryCount = 10) {
      // if the previewFile is there then no need to disable?
      if (this.$refs.formDropzoneComponentRef) {
        if (this.$refs.formDropzoneComponentRef.$refs.formDropzoneInstance) {
          this.$refs.formDropzoneComponentRef.$refs.formDropzoneInstance.disable();
        }
      } else if (retryCount > 0) {
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs.formDropzoneComponentRef) {
              if (this.$refs.formDropzoneComponentRef.$refs.formDropzoneInstance) {
                this.$refs.formDropzoneComponentRef.$refs.formDropzoneInstance.disable();
              }
            } else {
              this.disableFormDropZone(retryCount - 1);
            }
          });
        }, 450); // Retry every 400ms
      } else {
        console.warn("Dropzone ref not found after multiple retries.");
      }
    },

    enableFormDropZone(retryCount = 10){

      if (this.$refs.formDropzoneComponentRef) {
        this.$refs.formDropzoneComponentRef.$refs.formDropzoneInstance.enable();
      } else if (retryCount > 0) {
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs.formDropzoneComponentRef) {
              this.$refs.formDropzoneComponentRef.$refs.formDropzoneInstance.enable();
            } else {
              this.enableFormDropZone(retryCount - 1);
            }
          });
        }, 450); // Retry every 450ms
      } else {
        console.warn("Dropzone ref not found after multiple retries.");
      }
    },
    createButtonClicked(flag) {
      this.enableFormDropZone();
      this.createButtonClickedFlag = flag;
    },
    CreateQuote() {
      var self = this;
      var error = self.validateForm();
      if (!error && !self.orderQtyHasError) {
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/customer-order-form-prices",
          type: "POST",
          data: {
            orderType: self.orderType,
            class: self.select_class,
            batterySize: self.batterySize,
            wheelbase: self.wheelbase,
            addPto: self.addPto,
            addExtendedWarranty: self.extendedWarranty,
            highVoltageBattery: self.highVoltageBattery,
            powerTrain: self.powerTrain,
            hvee: self.hvee,
            allBundle: self.allBundle,
            deliveryArea: self.deliveryArea,
            colorWhite: self.colorWhite,
            vehicle_id: self.vehicle_id,
            customer_id: self.customer_id,
            vehicle_price: self.vehiclePrice,
            extended_warranty_fee: self.extendedWarrantyFee,
            delivery_fee: self.deliveryFee,
            dealer_id: self.dealer_id,
            dealer_address: self.dealer_address,
            consumer_id: self.consumer_id,
            consumer_address: self.consumer_address,
            // order_no: self.order_no,
            color: self.vehicle_color
          },
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          dataType: "json",
          success: function (data) {
            self.loading = false;
            self.vehiclePrice = data.content.vehiclePrice;
            self.deliveryFee = data.content.deliveryFee;
            self.extendedWarrantyFee = data.content.extendedWarrantyPrice;
            self.totalFee = data.content.totalFee;
            self.got_quote = true;
            self.path = data.content.path;
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data.content.path;
            link.download = '';
            link.target = "_blank";
            link.click();
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.got_quote = false;
            self.generateStatusCodeMessage(jqXHR, true, 'customer-order-form-create')
          }
        });
      } else {
        console.log('error');
      }
    },
    previewPdf() {
      var self = this;
      self.$router.push("/customer-order-form/preview");
    },
    onSearchAsset(search, loading) {
      var self = this;
      if (search.length > 3) {
        if (typeof loading === 'function') {
          loading(true); // Call the loading function if it's a function
        } else {
          self.loading = true;
        }
        // loading(true);
        self.searchField(loading, search, 'available_vehicles', '');
      }
    },

    // onSearchCustomer(search, loading) {
    //   var self = this;
    //   if (search.length > 2) {

    //     loading(true);
    //     self.searchField(loading, search, 'customer', '');
    //   }
    // },

    onSearchDealer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'dealer', '');
      }
    },

    onDealerChange() {
      var self = this;
      if (self.dealer_id.address_line_1 != null) {
        self.dealer_address = self.dealer_id.address_line_1;
      }
      if (this.consumer_id != null && this.consumer_id !== '') {
        if(
          this.consumer_id.mapped_customer_parent_id !== null
          &&
          this.consumer_id.mapped_customer_parent_id !== ""
          &&
          this.consumer_id.mapped_customer_parent_id !== undefined
        ){
          if (this.consumer_id.mapped_customer_parent_id !== this.dealer_id.parent_id) {
            this.consumer_id = null;
            this.consumerArr = [];
            this.consumer_address = '';
          }
        }
      }
    },

    onSearchConsumer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'consumer', self.dealer_id.parent_id);
      }
    },

    onConsumerChange() {
      var self = this;
      if (self.consumer_id.address_line_1 != null) {
        self.consumer_address = self.consumer_id.address_line_1;
      }
    },
    validateForm(flag) {
      var self = this;
      var error = false;

      self.order_type_error_msg = "";
      self.select_class_error_msg = "";
      self.select_battery_size_error_msg = "";
      self.select_wheelbase_error_msg = "";
      self.select_vehicle_option_error_msg = "";
      self.select_ext_warranty_error_msg = "";
      self.select_delivery_area_error_msg = "";
      self.is_the_color_white_error_msg = "";
      self.select_color_error_msg = "";
      self.consumer_error_msg = "";
      self.asset_error_msg = "";
      self.ordering_for_error_msg = "";
      self.purchase_order_error_msg = "";
      self.incentive_program_title_error_msg = "";
      self.incentive_program_error_msg = "";
      if (!this.orderQtyHasError) {
        self.order_quantity_error_msg = "";
      }
      self.dealer_error_msg = "";

      if (self.createButtonClickedFlag === "O" && !self.isEditPage) {
        if (self.purchase_order_no == null || self.purchase_order_no === "") {
          self.purchase_order_error_msg = "Purchase order# is required.";
          error = true;
        }
      }
      // if (self.orderType == null || self.orderType == "") {
      //   self.order_type_error_msg = "Please select order type.";
      //   error = true;
      // }

      if (self.orderingFor == null || self.orderingFor === "") {
        self.ordering_for_error_msg = "Please Select Ordering For.";
        error = true;
      }
      if (self.incentiveProgram == null || self.incentiveProgram === "") {
        self.incentive_program_error_msg = "Please Select Incentive Program.";
        error = true;
      }

      // if (self.orderType != null && self.orderType == 'Custom') {

      if (self.select_class == null || self.select_class == "") {
        self.select_class_error_msg = "Please Select Class.";
        error = true;
      }
      if (self.batterySize == null || self.batterySize == "") {
        self.select_battery_size_error_msg = "Please Select Battery Size.";
        error = true;
      }
      if (self.wheelbase == null || self.wheelbase === "") {
        self.select_wheelbase_error_msg = "Please Select Wheelbase.";
        error = true;
      }

      if (self.vehicle_option == null || self.vehicle_option == "") {
        self.select_vehicle_option_error_msg = "Please Select Vehicle Option.";
        error = true;
      }


      if (self.vehicle_color == null || self.vehicle_color === "") {
        self.select_color_error_msg = "Please Select Color.";
        error = true;
      }

      // }

      if (self.orderType != null && self.orderingFor === 'consumer') {
        if (self.consumer_id == null || !self.consumer_id.value) {
          self.consumer_error_msg = "Customer Is Required.";
          error = true;
        }
      }

      if (self.incentiveProgram === 'yes') {
        if (self.incentiveProgramTitle == null || self.incentiveProgramTitle === "") {
          self.incentive_program_title_error_msg = "Incentive Program Is Required.";
          error = true;
        }
      }

      //VIN required when order type In Stock or Only Extended Warranty
      // if (self.orderType != null && (self.orderType == 'In Stock' || self.orderType == 'Only Extended Warranty')) {
      //   if (self.vehicle_id == null || !self.vehicle_id.value) {
      //     self.asset_error_msg = "VIN Is Required.";
      //     error = true;
      //   }
      // }

      //select extended warranty required for all three types
      // if(self.orderType != null && self.orderType != '') {
      //   if (self.extendedWarranty == null || self.extendedWarranty == "") {
      //       self.select_ext_warranty_error_msg = "Please Select Ext. Warranty.";
      //       error = true;
      //   }
      // }

      //delivery area required when order type Custom or In Stock
      if (self.orderType != null) {
        if (self.deliveryArea == null || self.deliveryArea === "") {
          self.select_delivery_area_error_msg = "Please Select Delivery Area.";
          error = true;
        }
      }

      if (!this.orderQtyHasError) {
        if (self.order_qty === "" || self.order_qty < 1) {
          self.order_quantity_error_msg = "Order Quantity Is Required!";
          error = true;
        } else {
          if (self.order_qty > self.available_vehicles) {
            self.order_quantity_error_msg = "Order Quantity Must Be Less Than Available Vehicles!";
            error = true;
          }
        }
      }

      if (self.dealer_id === null || self.dealer_id === "") {
        self.dealer_error_msg = "Dealer Is Required!";
        error = true;
      }

      // if has error
      // scroll to that input
      if (error) {
        self.errorValidationFocus();
      }

      return error;
    },
    showSwalConfirmOrder(flag) {
      var self = this;
      var error = self.validateForm(flag);
      if (!error && !self.orderQtyHasError) {
        if (flag == 'O') {
          self.got_quote = false;
          self.$swal({
            title: 'Are you sure you want to place this order?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showCloseButton: false,
            showLoaderOnConfirm: true
          }).then((result) => {
            if (result.value) {
              if (!self.isEditPage) {
                self.PlaceOrder(flag);
              } else {
                $('#purchaseOrder').modal('show');
              }
            } else {
              self.loading = false;
            }
          });
        } else {
          self.PlaceOrder(flag);
        }
      } else {
        self.loading = false;
      }
    },
    PlaceOrder(flag) {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/vehicle-order/create",
        // url: process.env.ROOT_API + "/customer-order-form/create",
        type: "POST",
        data: {
          orderType: "In Stock", // passing in stock for now
          class: self.select_class,
          batterySize: self.batterySize,
          wheelbase: self.wheelbase,
          vehicleOption: self.vehicle_option,
          addExtendedWarranty: self.extendedWarranty,
          highVoltageBattery: self.highVoltageBattery,
          powerTrain: self.powerTrain,
          hvee: self.hvee,
          allBundle: self.allBundle,
          deliveryArea: self.deliveryArea,
          colorWhite: self.colorWhite,
          vehicle_id: self.vehicle_id,
          customer_id: self.customer_id,
          dealer_id: self.dealer_id,
          consumer_id: self.consumer_id,
          vehicle_price: self.amountFormatToFloat(self.purchase_price),
          extended_warranty_fee: self.extendedWarrantyFee,
          delivery_fee: self.deliveryFee,
          order_no: self.order_no,
          color: self.vehicle_color,
          got_quote: self.got_quote,
          path: self.path,
          customerOrderId: self.customerOrderId,
          flag: flag,
          orderingFor: self.orderingFor,
          docFilePath: self.files,
          purchaseOrderNo: self.purchase_order_no,
          incentiveProgram: self.incentiveProgram,
          incentiveProgramTitle: self.incentiveProgramTitle,
          orderQuantity: self.order_qty,
          totalFee: self.totalFee,
          grandTotalFee: self.grandTotalFee,
        },
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (flag == 'O') {
            $('#purchaseOrder').modal('hide');
            self.$router.push("/vehicle-order/list");
          } else {
            self.path = data.content.file_path;
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data.content.file_path;
            link.download = '';
            link.target = "_blank";
            link.click();
            self.$router.push({
              name: 'CustomerOrderFormEdit',
              params: {id: data.content.id},
            });

          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.got_quote = false;
          self.generateStatusCodeMessage(jqXHR, true, 'customer-order-form-create')
        }
      });
    },
    BackList() {
      var self = this;
      self.$router.push("/vehicle-order/list");
    },
    onChangeSize() {
      var self = this;
      self.wheelbase = '';
      if (self.batterySize == 'M') {
        self.wheelbaseArray = self.wheelbaseArrayM;
      } else if (self.batterySize == 'L') {
        self.wheelbaseArray = self.wheelbaseArrayL;
      }
    },
    onSearchAssetWithVin(search, loading) {
      var self = this;
      if (search.length > 3) {
        loading(true);
        self.searchField(loading, search, 'vehicle_vin', '');
      }
    },
    onLoadCustomerOrder() {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/customer-orders/view/" + self.customerOrderId,
        type: "GET",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.orderStatus = data.content.status;
          self.isExpired = data.content.is_expired;
          if (data.content.status == "Q") {
            self.orderButtonName = "Place Order";
          } else {
            self.orderButtonName = "Update Order";
            self.disableQuoteButton = true;
          }
          self.loading = false;
          if (data.status == "success") {
            if (data.content.status == "Q") {
              self.order_quote_number_label_name = "Quote Number:";
              self.order_quote_number = data.content.quote_number;
            } else {
              self.order_quote_number_label_name = "Order Number:";
              self.order_quote_number = data.content.order_no;
            }
            self.basePrice = data.content.basePrice;
            self.colorPrice = data.content.colorPrice;
            self.vehicle_id = {
              value: data.content.vehicle_id,
              text: data.content.vehicle_vin,
              year: data.content.vehicle_year,
              model: data.content.vehicle_model_name,
              make: data.content.manu_name,
              color: data.content.vehicle_color,
              option: data.content.vehicle_option_code,
              wheelbase: data.content.wheelbase,
            }; // need to set according to the order type in the backend.
            if (data.content.dealer_id > 0) {
              self.dealer_id = {
                value: data.content.dealer_id,
                text: data.content.dealer_code + " | " + data.content.dealer_name
              };
              self.dealer_address = data.content.dealer_address;
            }
            self.orderType = data.content.order_type;
            self.select_class = data.content.class;
            self.batterySize = data.content.battery_size;
            self.onChangeSize();
            if (data.content.vehicle_wheelbase != null) {
              self.wheelbase = data.content.vehicle_wheelbase;
            } else {
              self.wheelbase = data.content.wheelbase;
            }
            self.orderingFor = data.content.ordering_for;
            // self.addPto = data.content.pto;
            if (data.content.vehicle_option_id) {
              self.vehicle_option = {
                text: data.content.vehicle_option_code_new + ' - ' + data.content.vehicle_option_description,
                value: data.content.vehicle_option_id,
                price: data.content.vehicle_option_price,
                code: data.content.vehicle_option_code_new
              }
              self.vehicleOptionPrice = self.vehicle_option.price;
            } else {
              self.vehicle_option = '';
            }
            self.deliveryArea = data.content.delivery_area;
            self.vehiclePrice = data.content.vehicle_price;
            self.extendedWarrantyFee = data.content.extended_warranty_fee;
            self.deliveryFee = data.content.delivery_fee;
            // self.totalFee = self.vehiclePrice + self.extendedWarrantyFee + self.deliveryFee;

            self.vehiclePrice = self.vehiclePrice;
            self.deliveryFee = self.deliveryFee;
            self.extendedWarrantyFee = self.currencyFormat(self.extendedWarrantyFee);
            // self.totalFee = self.totalFee;
            if (data.content.color == 'White' || data.content.color == 'Natural White (W31)') {
              self.colorWhite = 'Yes';
            } else {
              self.colorWhite = 'No';
            }
            self.vehicle_color = data.content.color;
            self.extendedWarranty = data.content.extended_warranty;
            self.highVoltageBattery = data.content.high_voltage_battery;
            self.powerTrain = data.content.power_train;
            self.hvee = data.content.hvee;
            self.allBundle = data.content.all;
            if (data.content.has_incentive_program === 1) {
              self.incentiveProgram = "yes";
              self.incentiveProgramTitle = data.content.incentive_program_title;
            } else {
              self.incentiveProgram = "no";
            }

            if (data.content.consumer_id > 0) {
              self.consumer_address = data.content.consumer_address;
              self.consumer_id = {
                value: data.content.consumer_id,
                text: data.content.consumer_code + " | " + data.content.consumer_name,
                name: data.content.consumer_name,
                email: data.content.consumer_email,
                address_line_1: data.content.consumer_address,
                code: data.content.consumer_code,
              }
            }

            if (self.consumer_id != '') {
              self.consumer_for = true;
            } else {
              self.consumer_for = false;
            }

            if (self.highVoltageBattery == 1) {
              self.highVoltageBattery = true;
            } else {
              self.highVoltageBattery = false;
            }

            if (self.powerTrain == 1) {
              self.powerTrain = true;
            } else {
              self.powerTrain = false;
            }

            if (self.hvee == 1) {
              self.hvee = true;
            } else {
              self.hvee = false;
            }

            if (self.allBundle == 1) {
              self.allBundle = true;
            } else {
              self.allBundle = false;
            }

            if (data.content.doc_file_path != null || data.content.doc_file_path != '') {
              self.dropZonePreviewFiles = data.content.doc_file_path;
            }
            if(self.dropZonePreviewFiles == null){
              self.dropZonePreviewFiles = [];
            }
            self.previewFilesOnLoad = JSON.parse(JSON.stringify(self.dropZonePreviewFiles));
            if (data.content.status == "Q" && (data.content.purchase_order_no == "" || data.content.purchase_order_no == null)) {
              self.disablePurchaseOrderField = false;
            } else {
              self.disablePurchaseOrderField = true;
            }
            self.purchase_order_no = data.content.purchase_order_no;
            if (self.isEditPage && self.purchase_order_no != '') {
              self.purchase_order_msg = '';
            }
            self.user_email = data.content.created_by.email;
            self.order_qty = data.content.order_quantity;
            self.purchase_price = data.content.vehicle_price;
            self.totalFee = data.content.total_fee;
            self.grandTotalFee = data.content.grand_total_fee;
            if (self.$route.query.from != 'available_vehicles_list') {
              self.assignedVehiclesList.populateVehicles(data.content.get_assigned_vehicles);
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.errorOnLoad = true;
          self.generateStatusCodeMessage(jqXHR, false, 'group-by-id-load')
        }
      });
    },
    closePurchaseOrderModal() {
      if (
          this.$refs.modalDropzoneComponentRef
          &&
          this.$refs.modalDropzoneComponentRef.$refs.modalDropzoneInstance
      ) {
        this.$refs.modalDropzoneComponentRef.$refs.modalDropzoneInstance.removeAllFiles(true);
      }
      this.update_purchase_order_no = this.purchase_order_no;
      this.update_purchase_order_no_error_msg = '';
      this.doc_error_msg = '';
      this.files = [];
      this.dropZonePreviewFiles = JSON.parse(JSON.stringify(this.previewFilesOnLoad));

      $('#purchaseOrder').modal('hide');
    },
    checkPurchaseOrder() {
      this.update_purchase_order_no_error_msg = '';
      var success = true;

      if (
        this.update_purchase_order_no == ''
        ||
        this.update_purchase_order_no == null
      ) {
        this.update_purchase_order_no_error_msg = 'Purchase order# is required.';
        success = false;
      }

      if (success) {
        this.purchase_order_no = this.update_purchase_order_no;
        this.PlaceOrder('O');
      } else {
        this.errorValidationFocus();
      }
    },
    getCustomOrderVehiclePrices() {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/get-customer-order-pricing",
        type: "GET",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.customOrderPricesArr = data.content;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'group-by-id-load')
        }
      });
    },
    getCustomPrice(name) {
      const matchingPrice = this.customOrderPricesArr.find(
        (customOrderPrice) => customOrderPrice.name === name
      );
      if (matchingPrice) {
        return matchingPrice.price;
      } else {
        return 0
      }
    },
    // Utility method to ensure a numeric value
    ensureNumeric(value) {
      const numValue = Number(value); // Convert to number
      return isNaN(numValue) ? 0 : numValue; // Return 0 if NaN
    },
    areAllFieldsValid() {
      // Check all required fields except vehicle_color
      const isBasicFieldsFilled = this.vehicleSpecificationFields
        .every((field) => this[field] && this[field] !== "");

      return isBasicFieldsFilled;
    },
    getVehicleSpecificationDetails() {
      var self = this;
      var fields = {};
      this.vehicleSpecificationFields.forEach((item) => {
        fields[item] = this[item]; // Assign each field dynamically
      })
      // Your custom logic here

      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/vehicle_specifications",
        type: "POST",
        data: fields,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.content != null) {
            self.available_vehicles = data.content.available_vehicles;
            self.vehicles_pending_for_sale = data.content.vehicles_pending_for_sale;
            if (!self.isEditPage) {
              self.purchase_price = data.content.purchase_price;
            }
          } else {
            self.$swal('', `No vehicles are available for the selected specifications!`, 'warning');
            self.available_vehicles = 0;
            self.purchase_price = 0;
            self.vehicles_pending_for_sale = 0;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.got_quote = false;
          self.generateStatusCodeMessage(jqXHR, true, 'customer-order-form-create')
        }
      });
    },
    assignVehicle() {
      var fields = {};
      this.vehicleSpecificationFields.forEach((item) => {
        fields[item] = this[item]; // Assign each field dynamically
      });
      // this.$router.push("/available-vehicles-for-order/list?from=vehicle_order&order=" + this.customerOrderId);
      this.bypassConfirmation = true;
      this.$router.push(
        {
          path: "/available-vehicles-for-order/list",
          query: {
            from: "vehicle_order",
            order: this.customerOrderId,
            orderQuantity: this.order_qty - this.assignedVehicles.length,
            fields: JSON.stringify(fields), // Convert to string
          },
        }
      ).then(() => {
        window.history.replaceState({}, '', this.$route.path);
      });

    },
    unAssignVehicle(index) {
      this.assignedVehiclesList.popVehicle(index);
    },
    discardChangesSwal() {
      this.got_quote = false;
      this.$swal({
        title: 'Are you sure you want to discard changes made to this order?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.discardChanges();
        } else {
          this.loading = false;
        }
      });
    },
    discardChanges() {
      var self = this;
      self.loading = true;
      self.assignedVehiclesList.populateVehicles([]);
      self.loading = false;
      self.BackList();
    },
    updateAndClose() {
      var self = this;
      self.loading = true
      var fields = [];
      fields.push({name: 'vehicleIdArray', value: JSON.stringify(self.extractAssignedVehicleIds())}); // this should only have the ids
      fields.push({name: 'orderId', value: self.customerOrderId});
      $.ajax({
        url: process.env.ROOT_API + "/assign-vehicles-to-order",
        type: "POST",
        data: fields,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          self.assignedVehiclesList.populateVehicles([]);
          self.BackList();
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'customer-order-form-discard-changes');
        }
      });

    },
    extractAssignedVehicleIds() {
      return this.assignedVehicles.map(vehicle => vehicle.assigned_vehicle_id);
    },
    beforeWindowUnload(event) {
      if (this.canAssignVehicle && this.isEditPage) {
        event.preventDefault();
        event.returnValue = '';
      }
    },
    dealerIdChanged(value){
      if(value === '' || value === null){
        this.dealer_id = null;
      }
    },
    customerChanged(value){
      if(value === '' || value === null){
        this.consumer_id = null;
      }
    },
    deliveryAreaChanged(value){
      if(value === '' || value === null){
        this.deliveryArea = null;
      }
    },
    vehicleOptionChanged(value){
      if(value === '' || value === null){
        this.vehicle_option = null;
      }
    },
    colorChanged(value){
      if(value === '' || value === null){
        this.vehicle_color = null;
      }
    },
    wheelbaseChanged(value){
      if(value === '' || value === null){
        this.wheelbase = null;
      }
    },
    batterySizeChanged(value) {
      if (value === '' || value === null) {
        this.batterySize = null;
      }
    },
    classChanged(value){
      if(value === '' || value === null){
        this.select_class = null;
      }
    },
  }
};
</script>
<style scoped>
.loader-vvg {
  z-index: 1063;
}
.custom_vehicle_select >>> .vs__selected-options {
  white-space: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/components/asset/CustomerOrderForm.vue